/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
module.exports = {
  initialize(gridOptions, hiddenColIds, hiddenGroupids, restrictedColIds) {
    if (hiddenColIds == null) { hiddenColIds = []; }
    if (hiddenGroupids == null) { hiddenGroupids = []; }
    if (restrictedColIds == null) { restrictedColIds = []; }
    // Guard: #column-filters-switch is only rendered for high-level members
    if ($('#column-filters-switch').length === 0 || $('#column-filters').length === 0) {
      this._gridOptions = gridOptions;
      return this;
    }
    $('#column-filters').attr('tabindex', 0);

    this._gridOptions = gridOptions;
    this._gridOptions.onColumnMoved = this._saveColumnsOrder;
    this._gridOptions.onColumnResized = this._saveColumnsOrder;
    this._gridOptions.onColumnVisible = this._changeFilters;

    this._hiddenColIds = hiddenColIds;
    this._hiddenGroupIds = hiddenGroupids;
    this._restrictedColIds = restrictedColIds;
    this._initializeListeners();
    this._reorderColumns();
    this._filterColumns('#column-filters');
    return this;
  },

  // Compatibility: v35 merges columnApi into api; v19 UMD has separate columnApi
  _getColumnApi() {
    return this._gridOptions.columnApi || this._gridOptions.api;
  },

  _getApi() {
    return this._gridOptions.api;
  },

  // v35 compat: get grid element ID without gridCore
  _getGridId() {
    var api = this._getApi();
    if (api && typeof api.getGridId === 'function') {
      return api.getGridId();
    }
    // Fallback for older versions
    if (api && api.gridCore && api.gridCore.eGridDiv) {
      return api.gridCore.eGridDiv.id;
    }
    return 'unknown-grid';
  },

  _adjustColumnsToFit() {
    let widthVisibleColumns = 0;
    const gridWidth = document.getElementById("projects-index-table").offsetWidth;
    const visibleColumns = this._getColumnApi().getAllColumns().filter(c => c.isVisible());
    visibleColumns.map(c => widthVisibleColumns += c.getActualWidth());
    if (gridWidth > widthVisibleColumns) { return this._getApi().sizeColumnsToFit(); }
  },

  _initializeListeners() {
    $(document).on('change', '.col-visibility input[type="checkbox"]', _.bind(this._toggleGridColumn, this));
    return $(document).on('change', '.group-visibility input[type="checkbox"]', _.bind(this._toggleGridColumnGroup, this));
  },

  _changeFilters(event) {
    if (!event.column) { return; }
    const filterColumn = $('#column-filters').find('input[type=checkbox][data-col-id=' + event.column.colId + ']');
    filterColumn.prop('checked', event.visible);
    const spCheckbox = filterColumn.siblings('span.checkbox');
    if (!event.visible) { return spCheckbox.removeClass('checked'); }
  },

  _filterColumns(containerSelector) {
    const $container = $(containerSelector);

    return this._appendColumnFilters($container);
  },

  _appendColumnFilters($container) {
    const columnGroups = this._getColumnApi().getAllDisplayedColumnGroups();
    return _.each(columnGroups, columnGroup => {
      if (columnGroup.children) {
        const groupId = String(columnGroup.groupId);
        const checked = this._isColumnVisible({ id: groupId, type: 'group' }) ? 'checked' : null;
        const {
          headerName
        } = columnGroup.originalColumnGroup.colGroupDef;
        $container.append(this._groupFilterTemplate({ groupId, checked, headerName }));

        return this._appendColumnGroupChildren($container, columnGroup);
      } else {
        if (!_.include(this._restrictedColIds, columnGroup.colId)) {
          return this._appendColumn($container, columnGroup);
        }
      }
    });
  },

  _appendColumnGroupChildren($container, columnGroup) {
    return _.each(columnGroup.children, childColumn => {
      return this._appendColumn($container, childColumn);
    });
  },

  _appendColumn($container, column) {
    const colId = String(column.colId);
    const checked = this._isColumnVisible({ id: colId }) ? 'checked' : null;
    $container.append(this._columnFilterTemplate({ colId, checked, headerName: column.colDef.headerName }));
    return this._getColumnApi().setColumnVisible(colId, !!checked);
  },

  _filterTemplate: _.template(`
<div class='filtering-option align-left <%= filterType %>-visibility'>
<label class='custom-checkbox'>
<input type='checkbox' data-<%= filterType %>-id='<%= id %>' <%= checked %>>
<span class='checkbox'></span>
<span><%= headerName %></span>
</label>
</div>`),

  _columnFilterTemplate({ colId, checked, headerName }) {
    return this._filterTemplate({ id: colId, checked, headerName, filterType: 'col' });
  },

  _groupFilterTemplate({ groupId, checked, headerName }) {
    return this._filterTemplate({ id: groupId, checked, headerName, filterType: 'group' });
  },

  _toggleGridColumn(event) {
    const $target = $(event.currentTarget);
    const isChecked = $target.prop('checked');
    const colId = String($target.data('colId'));
    this._getColumnApi().setColumnVisible(colId, isChecked);
    this._saveFilter({ id: colId, isChecked });
    if (this._gridOptions.name === 'intelligence-projects-grid') {
      return this._adjustColumnsToFit();
    } else {
      return this._getApi().sizeColumnsToFit();
    }
  },

  _toggleGridColumnGroup(event) {
    const $target = $(event.currentTarget);
    const isChecked = $target.prop('checked');
    const groupId = String($target.data('groupId'));
    this._saveFilter({ id: groupId, isChecked, type: 'group' });

    this._toggleColumnGroupChildren({ groupId, isChecked });
    if (this._gridOptions.name === 'intelligence-projects-grid') {
      return this._adjustColumnsToFit();
    } else {
      return this._getApi().sizeColumnsToFit();
    }
  },


  _toggleColumnGroupChildren({ groupId, isChecked }) {
    const childrenColumns = this._groupChildrenColumns(groupId);

    _.each(childrenColumns, column => {
      const colId = String(column.colId);
      this._saveFilter({ id: colId, isChecked });
      return $(`.col-visibility input[type='checkbox'][data-col-id=${colId}]`).prop('checked', isChecked);
    });

    const childrenIds = _.pluck(childrenColumns, 'colId');
    return this._getColumnApi().setColumnsVisible(childrenIds, isChecked);
  },

  _groupChildrenColumns(groupId) {
    return this._getColumnApi().getAllColumns().filter(column => {
      return column.parent.groupId === groupId;
    });
  },

  _saveFilter(...args) {
    const obj = args[0],
      {
        id,
        isChecked
      } = obj,
      val = obj.type,
      type = val != null ? val : 'column';
    const cookieName = this._getFilterCookieName({ type });

    const savedFilters = $.cookie(cookieName);
    if (savedFilters) {
      const options = JSON.parse(savedFilters);
      options[id] = isChecked;
      return $.cookie(cookieName, JSON.stringify(options));
    } else {
      return $.cookie(cookieName, JSON.stringify({ [id]: isChecked }));
    }
  },

  _isColumnVisible(...args) {
    const obj = args[0],
      {
        id
      } = obj,
      val = obj.type,
      type = val != null ? val : 'column';
    const cookieName = this._getFilterCookieName({ type });

    const savedFilters = $.cookie(cookieName);
    if (savedFilters) {
      const savedFilterIdValue = JSON.parse(savedFilters)[id];
      if (savedFilterIdValue !== undefined) {
        return savedFilterIdValue;
      }
    }

    const hiddenIds = type === 'column' ? this._hiddenColIds : this._hiddenGroupIds;
    return !_.contains(hiddenIds, id);
  },

  _getFilterCookieName({ type }) {
    if (!['column', 'group'].includes(type)) { throw new Error("Invalid filter - type should be 'column' or 'group'"); }
    return `${this._getGridId()}-${type}-filters`;
  },

  _reorderColumns() {
    const cookieName = `${this._getGridId()}-column-order`;
    let columnState = $.cookie(cookieName);
    const colApi = this._getColumnApi();

    if (columnState && (colApi.getColumnState().length === JSON.parse(columnState).length)) {
      const parsedColumnState = JSON.parse(columnState);
      columnState = _.map(parsedColumnState, (column, index) => {
        const col = colApi.getColumn(column[0]);
        // Skip null columns (can happen when column definitions change)
        if (!col) { return null; }
        colApi.setColumnWidth(col, column[1]);
        colApi.moveColumn(column[0], index);
        return col;
      });
      // Filter out null values before setting column state
      columnState = _.compact(columnState);
      if (columnState.length > 0) {
        return colApi.setColumnState(columnState);
      }
    }
  },

  _saveColumnsOrder(gridOptions) {
    // v35: gridOptions event params may not have gridCore
    var gridId;
    var api = gridOptions.api || gridOptions.columnApi;
    if (api && typeof api.getGridId === 'function') {
      gridId = api.getGridId();
    } else if (api && api.gridCore && api.gridCore.eGridDiv) {
      gridId = api.gridCore.eGridDiv.id;
    } else {
      return; // Cannot save without grid ID
    }
    const cookieName = `${gridId}-column-order`;
    const colApi = gridOptions.columnApi || gridOptions.api;
    const columnState = _.map(colApi.getColumnState(), column => [column.colId, column.width]);
    return $.cookie(cookieName, JSON.stringify(columnState));
  }
};
